import React from 'react'
import { menuItems } from '../lib/FakeData';
import Navitem from './NavItem';
import TriggerMenusButton from './TriggerMenusButton';

const MenusHeader = () => {
  
    return (
        <div className='hidden lg:flex xl:flex w-full items-center justify-center bg-[--color-button-3] h-[60px] lg:px-2 xl:px-0 '>
            <div className='grid grid-cols-12 w-[--page-width] h-full items-center relative'>
                <div className='lg:col-span-3 xl:col-span-3'><TriggerMenusButton/></div>
                <div className='lg:col-span-9  col-span-9  flex gap-2 items-center'>
                    {menuItems && menuItems?.map((value, index) => {
                        return <Navitem key={index} item={value}/>
                    })}
                </div>
            </div>
        </div>
    )
}
export default MenusHeader;